export default {
  bank_account_status: 'Estado de verificación de la cuenta',
  delete_account: 'Eliminar cuenta',
  online_banking: 'Recarga por banca en línea',
  confirm_delete: 'Confirmar eliminación',
  bank_account_holder: 'Titular de la cuenta bancaria',
  add_new_bank_account: 'Añadir nueva cuenta bancaria',
  bank_account_list: 'Lista de cuentas bancarias',
  bank_wallet: 'Primera página de la cartilla / Billetera',
  cash_out_settng: 'Configuración de retiro',
  payment_account: 'Cuenta de origen de pago',
  withdrawal_period: 'Período de retiro',
  next_cash_out_date: 'Próxima fecha de retiro',
  fixed_amount: 'Monto fijo',
  offline_check: 'Recarga diferida (Cheque)',
  offline_cash: 'Recarga diferida (Efectivo)',
  qr_payment: 'Pago con QR',
  payment_type: 'Tipo de pago',
  upload_receipt: 'Subir recibo',
  upload_receipt_required: 'Subir recibo (obligatorio)',
  upload_receipt_tip: 'Puede subir hasta 5 imágenes.',
  balance_details: 'Detalles del saldo',
  recharge_record: 'Historial de recargas',
  withdraw_record: 'Historial de retiros',
  nsds_bill: 'Factura NSDS',
  Transfer_Record: 'Historial de transferencias',
  balance: 'Saldo',
  reverse: 'Reversión',
  payee_information: 'Información del beneficiario',
  select_bank: 'Seleccionar banco',
  top_up: 'Recargar',
  cash_out: 'Retirar fondos',
  cashout_fail: 'Retiro fallido',
  successfully_submit: 'Enviado con éxito',
  successfully_cash_out: 'RRetiro realizado con éxito',
  withdraw_success_tip: 'La solicitud de retiro ha sido enviada, esperando el procesamiento del banco',
  recharge_success_tip: 'Aún se requiere que realice la transferencia desde su tarjeta bancaria.',
  qr_tip_1: 'La orden de recarga vencerá en ',
  one_hour: '1h',
  qr_tip_2: ', por favor realice el pago lo antes posible',
  name: 'Nombre',
  account: 'Cuenta',
  mobile: 'Número de móvil',
  total_amount: 'Monto total',
  total_fee: 'Comisión total',
  total_count: 'Cantidad de transacciones total',
  remark: 'Nota / Comentario',
  related_merchants: 'Comercios asociados',
  transfer: 'Transferencia',
  transfer_amount: 'Monto de Transferencia',
  transfer_time: 'Tiempo de la transferencia',
  action_date: 'Fecha de acción',
  action_type: 'Tipo de transferencia',
  amount: 'Monto',
  deposit_no: 'Número de depósito',
  associated_merchant_id: 'ID del comercio asociado',
  associated_merchant_name: 'Nombre del comercio asociado',
  transfer_in_merchant_no: 'Número de comercio receptor',
  transfer_out_merchant_no: 'Número de comercio emisor',
  recharge_tip: 'Transfiera a esta cuenta bancaria y guarde el comprobante de transferencia.',
  recharge_tip_2: 'Realice la transferencia bancaria a esta cuenta. Conserve el comprobante de la transferencia.',
  loan_amount: 'Monto del pago',
  loan_number: 'Cantidad de pagos',
  loan_fee: 'Comisión de pago',
  loan_commission: 'Comisión de pago',
  collection_amount: 'Monto de cobro',
  collection_number: 'Cantidad de cobros',
  collection_fee: 'Comisión de cobro',
  collection_commission: 'Comisión de cobro',
  total_loan_amount: 'Monto total de pagos',
  total_loan_number: 'Cantidad total de pagos',
  total_loan_fee: 'Comisión total de pagos',
  total_collection_amount: 'Monto total de cobros',
  total_collection_number: 'Cantidad total de cobros',
  total_collection_fee: 'Comisión total de cobros',
  monthly_summary: 'Resumen de este mes',
  last_monthly_summary: 'Resumen del mes anterior',
  real_time_settlement_amount: 'Monto de liquidación en tiempo real',
  postpone_amount: 'Liquidación de adquirencia',
  frozen_amount: 'Monto congelado',
  unfrozen_amount: 'Monto descongelado',
  summary_details: 'Resumen de detalles',
  creation: 'Creación',
  submission: 'Envío',
  step: 'Paso',
  bank_details: 'Detalles del banco',
  company_address: 'Dirección de la empresa',
  enter_top_up_amount: 'Ingrese el monto de la recarga',
  amount_details: 'Detalles del monto',
  transfer_details: 'Detalles de la transferencia',
  sender: 'Remitente',
  receiver: 'Receptor',
  fee: 'Comisión',
  transactions_summary: 'Resumen de transacciones',
  total_transaction_details: 'Detalles totales de la transacción',
  filter_section: 'Filtrar',
  payin_transaction: 'Transacción de cobro (Pay-in)',
  payout_transaction: 'Transacción de pago (Pay-out)',
  refund_transaction: 'Transacción de reembolso',
  loan_transaction: 'Transacción de préstamo',
  repayment_transaction: 'Transacción de devolución',
  timeline: 'Cronología',
  paid: 'Monto de transacción',
  description: 'Descripción',
  payin_details: 'Detalles de cobro',
  payout_details: 'Detalles de pago',
  payin_created: 'Cobro creado',
  payin_completed: 'Cobro completado',
  payout_created: 'Pago creado',
  payout_completed: 'Pago completado',
  resend_notice: 'Reintentar notificación',
  download_details: 'Descarga de comprobante',
  download_time: 'Tiempo de descarga',
  payment_method_channel: 'Canal de pago',
  currency: 'Moneda',
  transaction_currency: 'Moneda de la transacción',
  top_up_currency: 'Moneda de recarga',
  usd_amount: 'Monto en USD',
  mxn_amount: 'Monto en MXN',
  abnormal_adjustment: 'Ajuste de disputas / errores',
  abnormal_adjustment_credit_balance: 'Ajuste de saldo entrante (Saldo disponible)',
  abnormal_adjustment_credit_frozen: 'Ajuste de saldo entrante (Monto congelado)',
  abnormal_adjustment_debit_balance: 'Ajuste de saldo saliente (Saldo disponible)',
  abnormal_adjustment_debit_frozen: 'Ajuste de saldo saliente (Monto congelado)',
  frozen_amount_balance: 'Saldo congelado',
  total_commission: 'Comisión total',
  commission: 'Comisión',
  remitting_bank: 'Banco remitente',
  remitting_account: 'Cuenta remitente',
  initiate_refund: 'Iniciar reembolso',
  full_refund: 'Reembolso total',
  partial_refund: 'Reembolso parcial',
  refund_amount: 'Monto de reembolso',
  refunded_transaction_fee: 'Monto de comisión devuelto',
  refund_number: 'Cantidad de reembolsos',
  refund_details: 'Detalles de reembolso',
  loan_detail: 'Detalle del préstamo',
  refund_amount_fail: 'Monto fallido de reembolso de pago',
  settlement_status: 'Estado de liquidación',
  estimated_settlement_time: 'Hora estimada de liquidación',
  actual_settlement_time: 'Hora real de liquidación',
  fail_reason: 'Motivo del fallo',
  back_to_balance: 'Volver al saldo de la cuenta',
  recharge_step_1_title: 'Paso 1: Seleccionar banco',
  recharge_step_2_title: 'Paso 2: Detalles de recarga',
  cash_out_amount: 'Monto a retirar',
  top_up_amount: 'Monto a recargar',
  scan_qr_code: 'Escanear código QR',
  refresh: 'Actualizar',
  proceed_to_payment: 'Proceder al pago',
  cash_out_amount_should: 'El monto de retiro debe ser ',
  minimum_cash_out_amount: 'Monto mínimo de retiro',
  pending_for_settlement: 'Pago exitoso, pendiente de acreditar en T+1',
  exchange_rate: 'Tipo de cambio',
  buy_currency: 'Moneda de compra',
  buy_amount: 'Monto de compra',
  sell_currency: 'Moneda de venta',
  sell_amount: 'Monto de venta',
  destination_amount: 'Monto recibido',
  source_amount: 'Monto de pago',
  quote_id: 'ID de cotización',
  exchange_transaction_id: 'Número de operación de cambio',
  fx_transaction_type: 'Tipo de transacción de cambio',
  base_currency: 'Moneda base',
  quote_currency: 'Moneda cotizada',
  quote_time: 'Hora de cotización',
  quote_expiry_time: 'Hora de vencimiento de cotización',
  document_proof: 'Documento probatorio',
  related_transactions: 'Transacciones relacionadas',
  fx_transfer_out_fee: 'Comisión por transferencia tras la conversión de divisas',
  fx_reversal_transfer_in_fee: 'Comisión por transferencia entrante por reversión de divisas',
  bill_details: 'Detalles de la factura',
  split_receiver: 'Beneficiario del reparto de fondos',
  split_transaction_no: 'Número de transacción del reparto de fondos',
  split_detail_transaction_no: 'Número del detalle de transacción del reparto de fondos',
  split_merchant_no_or_name: 'Número/Nombre del comercio financiador',
  receiver_type: 'Tipo de receptor',
  receiver_account: 'Cuenta del receptor',
  transaction_no: 'Número de transacción de cobro',
  split_merchant: 'Comercio financiador',
  receiver_name: 'Nombre del receptor',
  split_amount: 'Monto del reparto',
  receiver_relation: 'Relación con el receptor',
  relation_document: 'Documento de prueba de relación',
  add_receiver: 'Añadir beneficiario del reparto',
  edit_receiver: 'Editar beneficiario del reparto',
  split_transaction_detail: 'Detalles de la transacción de reparto',
  customize: 'Personalizar relación',
  uploaded: 'Subido',
  not_uploaded: 'No subido',
  account_location: 'Ubicación de la cuenta bancaria',
  account_location_local: 'Local',
  account_location_overseas: 'Extranjero',
  bank_address: 'Dirección del banco',
  swift_code: 'SWIFT',
  bank_wallet_tooltip: 'Debe incluir: número de cuenta, nombre de la cuenta y nombre del banco',
  currency_required: 'La moneda no puede estar vacía',
  account_location_required: 'La ubicación de la cuenta bancaria no puede estar vacía',
  bank_address_required: 'Por favor, ingrese la dirección del banco',
  swift_code_required: 'Por favor, ingrese el código SWIFT',
  bank_account_proof: 'Documento probatorio de la cuenta bancaria',
  invoice_image: 'Factura',
  nick_name: 'Alias',
  withdrawal_amount: 'Monto de retiro',
  amount_received: 'Monto recibido',
  refresh_exchange_rate: 'Actualizar tipo de cambio',
  refresh_exchange_rate_after: 'Actualizar en {time}',
  withdraw_information_confirmation: 'Confirmación de la información de retiro',
  confirm_cash_out_title: 'Confirmar',
  confirm_cash_out_message: '¿Está seguro de que desea confirmar este retiro?',
  confirm_cash_out_btn: 'Confirmar',
  cancel_cash_out_btn: 'Cancelar',
  withdraw_currency: 'Moneda de retiro',
  arrive_currency: 'Moneda de recepción',
  fee_currency: 'Moneda de la comisión de servicio',
  card_verification_count: 'Cantidad de verificaciones de tarjeta',
  card_verification_fee: 'Comisión por verificación de tarjeta',
  card_verification_failed_fee_refund: 'Reembolso de comisión por verificación de tarjeta fallida',
  card_verification_list: 'Lista de verificaciones de tarjeta',
  card_verification_details: 'Detalles de verificación de tarjeta',
  card_verification_info: 'Información de verificación de tarjeta',
  basic_info: 'Información básica',
  time_info: 'Información de tiempo',
  recipient_name: 'Nombre del beneficiario',
  bank_wallet_name: 'Nombre del banco o de la billetera',
  verification_type: 'Tipo de verificación de tarjeta',
  cardholder_real_name: 'Nombre real del titular de tarjeta',
  transaction_id: 'Número de transacción',
  merchant_order_id: 'ID de orden del comercio',
  account_no: 'Número de cuenta',
  account_bank_code: 'Código bancario de la cuenta',
  account_name: 'Nombre de la cuenta',
  account_status: 'Estado de la cuenta',
  order_status: 'Estado de la orden',
  failed_message: 'Mensaje de error de verificación de tarjeta',
  name_match_result: 'Resultado de coincidencia de nombre',
  account_type: 'Tipo de cuenta',
  institute_transaction_id: 'Número de transacción de la institución',
  institute_name: 'Nombre de la institución',
  channel_name: 'Nombre del canal',
  validation_amount: 'Monto de validación',
  validation_currency: 'Moneda de validación',
  fee_split: 'Monto de la comisión compartida',
  fee_split_currency: 'Moneda de la comisión compartida',
  account_validate_result: 'Resultado de validación de la cuenta',
  transaction_status: 'Estado de la transacción',
  card_verifying: 'Verificando tarjeta...',
  card_verification_success: 'Verificación de tarjeta exitosa',
  card_verification_failed: 'Verificación de tarjeta fallida',
  card_verification_cost: 'Costo de verificación de tarjeta',
  account_type_bank: 'BANCO',
  account_type_va: 'VA',
  account_type_ewallet: 'Billetera digital',
  account_type_unknown: 'Desconocido',
  failure_message: 'Mensaje de fallo',
  account_kyc_result: 'Estado real de KYC de la cuenta',
  account_name_match: 'COINCIDE',
  account_name_not_match: 'NO_COINCIDE',
  account_name_unknown: 'DESCONOCIDO',
  account_validate_valid: 'VÁLIDA',
  account_validate_invalid: 'NO_VÁLIDA',
  account_validate_unknown: 'DESCONOCIDO',
  status_pending: 'Pendiente',
  status_success: 'Éxito',
  status_failed: 'Fallido',
  account_actual_type: 'Tipo real de la cuenta'
}
